module.exports = __webpack_public_path__ + "static/media/virtual-logo2.5df22cae.png";